// Deterministic noise helpers shared by all procedural FX

/**
 * Hash three integers to a float in [0, 1].
 */
export function hash01(a, b, c) {
  let h = (Math.imul(a, 374761393) + Math.imul(b, 668265263) + Math.imul(c, 2147483647)) | 0;
  h = Math.imul(h ^ (h >>> 13), 1274126177);
  h = h ^ (h >>> 16);
  return (h & 0x7fffffff) / 0x7fffffff;
}

/**
 * Smooth value noise in 2D.
 * Inputs x, y may be any float. The optional third arg `seed` allows
 * time-varying noise by passing e.g. Math.floor(nowMs / 250).
 * Returns a value in [0, 1].
 */
export function noise2D(x, y, seed = 0) {
  const ix = Math.floor(x);
  const iy = Math.floor(y);
  const fx = x - ix;
  const fy = y - iy;

  const n00 = hash01(ix,     iy,     seed);
  const n10 = hash01(ix + 1, iy,     seed);
  const n01 = hash01(ix,     iy + 1, seed);
  const n11 = hash01(ix + 1, iy + 1, seed);

  // Cubic smoothstep
  const ux = fx * fx * (3 - 2 * fx);
  const uy = fy * fy * (3 - 2 * fy);

  return n00 + (n10 - n00) * ux + (n01 - n00) * uy + (n00 - n10 - n01 + n11) * ux * uy;
}

/** Linear interpolation */
export function lerp(a, b, t) {
  return a + (b - a) * t;
}
